import template from "./bAsyncSearch.html";

export function bAsyncSearchDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: bAsyncSearchController,
    controllerAs: 'bAsyncSearch',
    bindToController: true,
    scope: {
      name: '@',
      match: '<',
      onSearch: '&',
      onSelect: '&',
      displayExtraField: '&',
      minChars: '=?',
      debounce: '=?',
      placeholder: '=?',
      tooltip: '=?',
      select: '=?',
      customDisplayFn: '&?'
    }
  };

  return directive;
}

class bAsyncSearchController {
  constructor() {
    'ngInject';

    this.$onInit = () => {
      this.displayedData = [];
      this.isLoading = false;
      this.search = false;
      this.searchQuery = '';
      this.lastSearchQuery = null;
      this.MIN_CHARS = typeof this.minChars !== 'undefined' ? parseInt(this.minChars) : 3;
      this.debounce = this.debounce || 1_000;
    };
  }

  handleSearch(forceSearch = false) {
    if (this.onSearch && this.lastSearchQuery !== this.searchQuery) {
      this.displayedData = [];

      if (forceSearch || this.searchQuery.length >= this.MIN_CHARS) {
        this.isLoading = true;
        this.lastSearchQuery = this.searchQuery;

        this.onSearch({ query: this.searchQuery })
          .then((results) => {
            this.displayedData = results;
          })
          .finally(() => {
            this.isLoading = false;
            this.lastSearchQuery = null;
          });
      } 
      else if (this.searchQuery.length === 0 && forceSearch) {
        this.isLoading = true;
        
        this.onSearch({ query: '' })
          .then(function(results) {
            this.displayedData = results;
          })
          .finally(function() {
            this.isLoading = false;
          });
      }
    }
  }

  handleSearchWithValidation() {
    this.handleSearch(false);
  }

  handleKeyPress(event) {
    if (event.keyCode === 13) {
      this.handleSearch(true);
    }
  }

  toggleSearch() {
    this.search = !this.search;
    if (!this.search) {
      this.searchQuery = '';
      this.displayedData = [];
    }
  }

  selectItem(item) {
    this.select = item;
    this.search = false;
    if (this.onSelect) {
      this.onSelect({ item: item });
    }
  }

  resetSearch() {
    this.searchQuery = this.match || '';
    this.handleSearch();
  }
}
